<template>
  <v-dialog
    v-model="show"
    max-width="600px"
  >
    <v-card>
      <v-card-title>
        Request For Bonus {{ !this.canMakeRequest ? '(You must be either supervisor or have manager role)' : '' }}
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click.prevent="show = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-2">
        <v-expansion-panels :disabled="!canMakeRequest" v-model="firstPanel">
          <v-expansion-panel>
            <v-expansion-panel-header class="ml-0">Bonus amount</v-expansion-panel-header>
            <v-expansion-panel-content>
              Choose employee from the list and set bonus amount (USD).
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row>
          <v-col>
            <v-select
              :disabled="!canMakeRequest"
              label="Employee"
              :items="filteredEmployee"
              item-text="Full_Name"
              item-value="Employee_ID"
              v-model="luckyOne"
            >
              <template v-slot:prepend-item>
                <div class="px-4 py-2">
                  <v-text-field
                    dense
                    hide-details
                    label="Search employee"
                    v-model="searchEmployee"
                  ></v-text-field>
                </div>
                <v-divider></v-divider>
              </template>
            </v-select>
          </v-col>
          <v-col>
            <v-text-field
              :disabled="!canMakeRequest"
              class="inputAmount"
              label="Amount requested"
              type="number"
              v-model="computedRequestedAmount"
            ></v-text-field>
          </v-col>
          <v-expansion-panels :disabled="!canMakeRequest" v-model="secondPanel">
            <v-expansion-panel>
              <v-expansion-panel-header class="ml-0">Confirmation fields</v-expansion-panel-header>
              <v-expansion-panel-content>
                Please, provide confirmation file (e.g. screenshot of AM's or CEO's approval) as well as justification reason for bonus payment.
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-col>
            <v-file-input
              :disabled="!canMakeRequest"
              label="Confirmation file"
              v-model="confirmationFile.file"
              @change="onFileChange"
              show-size
              counter
              :accept="ALLOWED_FILE_TYPES"
            ></v-file-input>
          </v-col>
          <v-col>
            <v-textarea
              :disabled="!canMakeRequest"
              rows="1"
              label="Reason"
              v-model="reason"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small :loading="isLoading" :disabled="!isRequestReady || !isRequestAppropriate || isLoading" color="primary" @click="sendRequest">Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ALLOWED_FILE_TYPES } from '@/constants/fileAccept'
import { getApiErrorMessage } from '@/utils/apiError'
import { formatLocalDate } from '@/utils/dateUtils'
import { fileToDataUrl } from '@/utils/fileDataUrl'

export default {
  name: 'BonusRequest',
  props: {
    value: {
      required: true,
      default: false
    },
    requestId: {
      type: Number,
      default: null
    }
  },
  mounted () {
    if (this.isNotProduction) {
      this.CEOId = this.user.employee_id
    }
    if (!this.employeeList.length) this.getEmployeeList()

    if (this.requestId) {
      this.getBonusRequest(this.requestId)
    }
  },
  data () {
    return {
      isRequestAppropriate: true,
      isLoading: false,
      isNotProduction: process.env.NODE_ENV !== 'production',
      CEOId: 2,
      CEO: null,
      firstPanel: 0,
      secondPanel: 0,
      isNewConfirmationFile: false,
      searchEmployee: '',
      luckyOne: null,
      requestedAmount: null,
      reason: null,
      ALLOWED_FILE_TYPES,
      confirmationFile: {
        file: null,
        File_Name: '',
        File_Type: ''
      }
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
        if (this.value) {
          this.clearAll()
          this.$emit('getHistory')
          this.isRequestAppropriate = true
        }
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    employeeList () {
      return this.$store.getters.getEmployee
    },
    roles () {
      return this.$store.getters.getEmployeeRoles
    },
    validEmployee () {
      return this.$store.getters.getAllEmployee.filter(item => {
        return !item.Is_Deleted &&
          (item.Left_Date ? new Date(item.Left_Date) > new Date() : true)
      })
    },
    filteredEmployee () {
      const isOnlySupervisor = !this.roles.manager.val
      const r = new RegExp(this.searchEmployee, 'gi')
      const empl = this.validEmployee.filter(item => {
        if (!(isOnlySupervisor && (item.Supervisor_ID !== this.user.employee_id))) {
          r.lastIndex = 0
          const test = r.test(item.Name + ' ' + item.Last_Name)
          return test
        }
        return false
      })
      empl.forEach(item => { item.Full_Name = item.Name + ' ' + item.Last_Name })
      return empl
    },
    computedRequestedAmount: {
      get () {
        return this.requestedAmount
      },
      set (value) {
        if (value < 0) {
          this.requestedAmount = -value
        } else {
          this.requestedAmount = value
        }
      }
    },
    isRequestReady () {
      return this.luckyOne &&
        this.computedRequestedAmount &&
        this.reason
    },
    canMakeRequest () {
      if (this.roles.manager.val) return true
      let res = false
      for (const i of this.validEmployee) {
        if (i.Supervisor_ID === this.user.employee_id) {
          res = true
          break
        }
      }
      return res
    }
  },
  methods: {
    getEmployeeList () {
      this.axios.get('/api/employeelist', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setEmployeeList', { employeeList: response.data })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getBonusRequest (requestId) {
      this.axios.get(`/api/requests/bonus_by_id/${requestId}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(async res => {
        const data = res.data[0]
        this.luckyOne = data.Employee_ID
        this.requestedAmount = data.Amount_Of_Bonus
        this.reason = data.Reason
        this.confirmationFile.file = this.bufferToFile(data.Confirmation_File?.data, data.Confirmation_File_Type, data.Confirmation_File_Name)
        await this.onFileChange(this.confirmationFile.file)
        this.isNewConfirmationFile = false
      }).catch(err => {
        const errorMsg = getApiErrorMessage(err)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    sendRequest () {
      this.isLoading = true
      this.isRequestAppropriate = false
      this.CEO = this.employeeList.find(item => item.employee_id === this.CEOId)

      if (!this.confirmationFile.file) {
        this.confirmationFile.File_Name = ''
        this.confirmationFile.File_Type = ''
      }

      const headers = {
        Authorization: `Bearer ${this.user.token}`
      }

      const basePayload = {
        Amount_Of_Bonus: this.computedRequestedAmount,
        Employee_ID: this.luckyOne,
        File: this.confirmationFile,
        Reason: this.reason,
        isNewConfirmationFile: this.isNewConfirmationFile
      }

      if (this.requestId) {
        this.axios.put(`/api/requests/bonus_request/${this.requestId}`, basePayload, { headers })
          .then((res) => {
            this.$store.dispatch('setSuccess', { successMsg: 'Bonus request details were updated.' })
            return this.axios.delete(`/api/notifications/${res.data[0].Notification_ID}`, { headers })
          })
          .then(() => {
            return this.createBonusNotification()
          })
          .then((newNotificationResponse) => {
            const newNotificationId = newNotificationResponse.data[0].Notification_ID
            const updatePayload = {
              Notification_ID: newNotificationId
            }
            return this.axios.put(`/api/requests/update_notification_bonus_request/${this.requestId}`, updatePayload, { headers })
          })
          .then(() => {
            this.sendEmailForBonusRequest(this.requestId)
            this.$store.dispatch('setSuccess', { successMsg: 'Bonus request was fully updated.' })
            this.show = false
          })
          .catch(err => {
            this.isRequestAppropriate = true
            const errorMsg = getApiErrorMessage(err)
            this.$store.dispatch('setError', { errorMsg })
          }).finally(() => {
            this.isLoading = false
          })
      } else {
        this.createBonusNotification()
          .then(response => {
            const newNotificationId = response.data[0].Notification_ID

            const payload = {
              ...basePayload,
              Creator_ID: this.user.employee_id,
              Confirmer_ID: this.CEO.employee_id,
              Payout_Month: formatLocalDate(),
              Notification_ID: newNotificationId
            }

            return this.axios.post('/api/requests/bonus', payload, { headers })
          })
          .then(result => {
            const newRequestId = result.data[0].Request_ID
            this.sendEmailForBonusRequest(newRequestId)

            this.show = false
            this.$store.dispatch('setSuccess', { successMsg: 'Request for bonus was made' })
          })
          .catch(error => {
            this.isRequestAppropriate = true
            const errorMsg = getApiErrorMessage(error)
            this.$store.dispatch('setError', { errorMsg })
          }).finally(() => {
            this.isLoading = false
          })
      }
    },
    createBonusNotification () {
      const luckyOneData = this.filteredEmployee.find(item => item.Employee_ID === this.luckyOne)

      const notificationData = {
        Notification_Message: `
          Requester:  ${this.user.full_name},
          Bonus amount: ${this.requestedAmount} $,
          Reason: ${this.reason}
        `,
        Notification_Title: `Bonus request for ${luckyOneData.Full_Name}`,
        Notification_Created: formatLocalDate(),
        Notification_Employee_ID_From: this.user.employee_id,
        Notification_Employee_ID_To: this.CEO.employee_id,
        Notification_Type_ID: 1
      }

      const headers = {
        Authorization: 'Bearer ' + this.user.token
      }

      return this.axios.post('/api/notifications', notificationData, { headers })
    },
    bufferToFile (bufferData, mimetype, filename) {
      if (!bufferData || !mimetype || !filename) return null
      const byteArray = new Uint8Array(bufferData)
      return new File([byteArray], filename, {
        type: mimetype,
        lastModified: Date.now()
      })
    },
    async onFileChange (e) {
      if (!e) {
        this.confirmationFile = { file: null, File_Name: '', File_Type: '' }
        this.isNewConfirmationFile = true
        return
      }
      try {
        const res = await fileToDataUrl(e)
        this.confirmationFile.File_Name = e.name
        this.confirmationFile.File_Type = e.type
        if (this.confirmationFile.file) {
          this.confirmationFile.file.data = res.data
          this.confirmationFile.file.base64String = res.base64String
        }
        this.isNewConfirmationFile = true
      } catch (error) {
        this.confirmationFile = { file: null, File_Name: '', File_Type: '' }
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      }
    },
    clearAll () {
      this.luckyOne = null
      this.requestedAmount = null
      this.confirmationFile = {
        file: null,
        File_Name: '',
        File_Type: ''
      }
      this.reason = null
    },
    sendEmailForBonusRequest (requestId) {
      const body = {
        Request_ID: requestId
      }
      this.axios.post('/api/emails/sendemailforbonusrequest', body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  }
}
</script>
<style>
.inputAmount input[type='number'] {
    -moz-appearance:textfield;
}
.inputAmount input::-webkit-outer-spin-button,
.inputAmount input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>
